'use client'

import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton'
import { Link } from '@/lib/i18n/settings'

export default function LinkListItemButton({ children, href, ...rest }: Omit<ListItemButtonProps, 'component'> & { href: string }) {
  const props = {
    ...rest,
    component: Link,
    href,
  }
  return <ListItemButton {...props}>{children}</ListItemButton>
}
